import React, { useState } from 'react';
import axios, { AxiosError } from 'axios';
import { FaUser, FaEnvelope, FaLock } from 'react-icons/fa';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from 'react-router-dom';

const Register: React.FC = () => {

  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    phone: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // 🔐 Password Validation
    if (form.password !== form.confirmPassword) {
      toast.error("❌ Password & Confirm Password do not match!");
      return;
    }

    try {
      const response = await axios.post(
        'https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net/SignUp/CustomerSignUp',
        {
          name: form.name,
          email: form.email,
          password: form.password,
          confirmPassword: form.confirmPassword,
          phone: form.phone,
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      );

      console.log('✅ Registered successfully:', response.data);
      
      // Store customer info after registration
      if (response.data?.customerId) {
        localStorage.setItem('customerId', response.data.customerId);
        localStorage.setItem('customerName', response.data.customerName);
      }
      
      toast.success('🎉 Registered successfully!');
      
      // Redirect to login after registration
      setTimeout(() => {
        window.location.href = '/login';
      }, 1500);

      setForm({
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        phone: '',
      });

    } catch (err) {
      const axiosError = err as AxiosError;
      console.error('❌ Registration error:', axiosError.message);
      toast.error('❌ Failed to register. Please try again.');
    }
  };

  return (
    <div className="auth-bg d-flex justify-content-center align-items-center min-vh-100"
      style={{
        background: "linear-gradient(to right, #f3f3f3, #e0ffe0)",
        backgroundImage: `url('/images/ppbg.jpg')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}>
      <div
        className="card shadow-lg p-5 rounded-4 bg-white"
        style={{
          width: "100%",
          maxWidth: "450px",
          maxHeight: "90vh",
          overflowY: "scroll",
          scrollbarWidth: "none",      
          msOverflowStyle: "none",      
        }}
      >
        <div className="text-center mb-4">
          <img src="/images/fhome-logo.jpg" alt="Logo" style={{ height: 60, width: 80 }} />
          <h4 className="mt-3 fw-bold">Create Your Account</h4>
        </div>

        <form onSubmit={handleSubmit}>

          {/* Name */}
          <div className="form-group mb-3">
            <label><FaUser className="me-2" /> Name</label>
            <input
              type="text"
              name="name"
              className="form-control rounded-3"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>

          {/* Email */}
          <div className="form-group mb-3">
            <label><FaEnvelope className="me-2" /> Email</label>
            <input
              type="email"
              name="email"
              className="form-control rounded-3"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>

          {/* Phone */}
          <div className="form-group mb-3">
            <label>Phone</label>
            <input
              type="text"
              name="phone"
              className="form-control rounded-3"
              value={form.phone}
              onChange={handleChange}
              required
            />
          </div>

          {/* Password */}
          <div className="form-group mb-3">
            <label><FaLock className="me-2" /> Password</label>
            <input
              type="password"
              name="password"
              className="form-control rounded-3"
              value={form.password}
              onChange={handleChange}
              required
            />
          </div>

          {/* Confirm Password */}
          <div className="form-group mb-4">
            <label><FaLock className="me-2" /> Confirm Password</label>
            <input
              type="password"
              name="confirmPassword"
              className="form-control rounded-3"
              value={form.confirmPassword}
              onChange={handleChange}
              required
            />
          </div>

          <ToastContainer position="top-right" autoClose={3000} theme="colored" />

          <button type="submit" className="btn btn-primary w-100 py-2 rounded-3">
            Sign Up
          </button>

        </form>

        <p className="text-center mt-3 mb-0">
          Already a member? <Link to="/login" className="text-decoration-none">Login</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;

